export default __webpack_public_path__ + "static/media/BOOK  56649 - Máq. 16ton longo.b2a30188.pdf";